<template>
    <div class="app">
        <alert-banners />

        <app-loader v-if="is_design_v2 === null" />
        <app-vue v-if="is_design_v2 === false" />
        <app-react v-if="is_design_v2 === true" />

        <div class="overlay">
            <switch-design-v2 />

            <TollFreeDeleteModal />
            <TollFreeDetailsModal />
            <TollFreeVerificationAI />
            <TollFreeAddNumbersModal />
            <TollFreeAddNumberModal />

            <ShakenStirDeleteModal />
            <ShakenStirAdvanced />
            <CNAMCallerID />
            <CNAMDelete />
            <CNAMEdit />
            <TrustedCallingBuy
                @handle-show-shaken-stir-advanced="handleShowShakenStirAdvanced"
                @handle-show-c-n-a-m-caller-i-d="handleShowCNAMCallerID"
            />
            <VoiceIntegrityModal @closed="closeVoiceIntegrityModal()" />

            <upgrade-plan-modal
                :show="earlyUpgradeShown"
                :use-downgrade="earlyDowngradeShown"
                @close="hideEarlyUpgrade"
            />
            <upgrade-plan-trial-modal @close="hideEarlyUpgrade" />

            <div id="app-overlay"></div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'pinia';
import stores from 'store/modules';
import AppVue from './AppVue.vue';
import AppReact from './AppReact.vue';
import PublicApiMixin from './mixins/public-api';
import echoUserMixin from 'mixins/echo/user';

import AppVueMixin from './mixins/app-vue';
import FeatureablesMixin from 'mixins/featureables';
import OrganizationMixin from 'mixins/organization';
import AddFundsMixin from 'mixins/add-funds';
import EarlyUpgradeMixin from 'mixins/early-upgrade';

import { startExistFunction } from 'utils/startExistFunction';
import TollFreeAddNumbersModal from 'views/Settings/Organization/Settings/Compliance/TollFree/TollFreeAddNumbersModal/TollFreeAddNumbersModal.vue';
import TollFreeAddNumberModal from 'views/Settings/Organization/Settings/Compliance/TollFree/TollFreeAddNumberModal/TollFreeAddNumberModal.vue';
import TollFreeVerificationAI from 'views/Settings/Organization/Settings/Compliance/TollFree/TollFreeVerification/TollFreeVerificationAI.vue';
import TollFreeDeleteModal from 'views/Settings/Organization/Settings/Compliance/TollFree/TollFreeDeleteModal/TollFreeDeleteModal.vue';
import TollFreeDetailsModal from 'views/Settings/Organization/Settings/Compliance/TollFree/TollFreeDetailsModal/TollFreeDetailsModal.vue';
import AlertBanners from 'components/AlertBanners/AlertBanners.vue';
import UpgradePlanTrialModal from 'components/Billing/UpgradePlanTrialModal.vue';
import UpgradePlanModal from 'components/Billing/UpgradePlanModal/UpgradePlanModal.vue';
import ShakenStirDeleteModal from 'views/Settings/Organization/Settings/Compliance/Calling/ShakenStirDeleteModal.vue';
import ShakenStirAdvanced from 'views/Settings/Organization/Settings/Compliance/Calling/ShakenStirAdvanced.vue';
import CNAMCallerID from 'views/Settings/Organization/Settings/Compliance/Calling/CNAMCallerID.vue';
import CNAMDelete from 'views/Settings/Organization/Settings/Compliance/Calling/CNAMDelete.vue';
import CNAMEdit from 'views/Settings/Organization/Settings/Compliance/Calling/CNAMEdit.vue';
import TrustedCallingBuy from 'views/Settings/Organization/Settings/Compliance/Calling/TrustedCallingBuy.vue';
import VoiceIntegrityModal from 'views/Settings/Organization/Settings/Compliance/Calling/VoiceIntegrityModal/VoiceIntegrityModal.vue';

export default {
    components: {
        VoiceIntegrityModal,
        TrustedCallingBuy,
        CNAMEdit,
        CNAMDelete,
        CNAMCallerID,
        ShakenStirAdvanced,
        ShakenStirDeleteModal,
        UpgradePlanModal,
        UpgradePlanTrialModal,
        AlertBanners,
        TollFreeDetailsModal,
        TollFreeDeleteModal,
        TollFreeVerificationAI,
        TollFreeAddNumberModal,
        TollFreeAddNumbersModal,
        AppVue,
        AppReact,
    },

    mixins: [
        echoUserMixin,
        AppVueMixin,
        FeatureablesMixin,
        PublicApiMixin,
        OrganizationMixin,
        AddFundsMixin,
        EarlyUpgradeMixin,
    ],

    data() {
        return {
            is_design_enable_v2: null,
            is_design_v2: null,
            is_calling_ready: false,
        };
    },

    computed: {
        ...mapState(stores.User, ['user', 'loadingApp']),
        ...mapState(stores.Subscriptions, ['subscription']),
        ...mapState(stores.Inboxes, ['inboxesArray']),
    },

    watch: {
        'user.id'(value) {
            if (value) {
                this.initIntegrationsEcho();
            } else {
                this.resetIntegrationsEcho();
            }
        },

        loadingApp(value) {
            if (!value) {
                this.initVue();
                this.initDesignV2();
            }
        },
        async '$route.path'(value) {
            this.watchDesignV2(value);
        },
    },

    methods: {
        initDesignV2() {
            this.is_design_v2 = DesignV2API.handleCheckPage();
            this.is_design_enable_v2 = this.hasFeatureUser('salesmsg-design-v2');
        },

        initCall() {
            if (this.is_calling_ready) return;
            this.is_calling_ready = true;
            startExistFunction('initCallPopup', 50);
        },

        initOverlayReact() {
            startExistFunction('initOverlayReact', 50, 'app-overlay');
        },

        watchCallPopup() {
            this.$watch(
                () => ({
                    user_id: this.user?.id,
                }),
                ({ user_id }) => {
                    if (!user_id) return;
                    this.initCall();
                },
                {
                    immediate: true,
                }
            );
        },

        watchDesignV2(value) {
            this.is_design_v2 = DesignV2API.handleCheckPage(value);

            DesignV2API.initWatch(value);
        },
    },

    mounted() {
        this.initOverlayReact();
        this.watchCallPopup();
    },
};
</script>

<style lang="scss" scoped>
@import './styles';
</style>
